import { Injectable } from '@angular/core';
import {
  Router,
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TriggerApiService } from '../_services/trigger-api.service';

@Injectable({
  providedIn: 'root'
})
export class TriggerResolver implements Resolve<any> {
  constructor(private triggerApiService: TriggerApiService) {}

  async resolve(route: ActivatedRouteSnapshot): Promise<Observable<any>> {
    return (await this.triggerApiService.getAllTriggers()).pipe(
      catchError(() => {
        return EMPTY;
      })
    );
  }
}
